import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { createWorkGroup } from '../../api/workGroups.js'
import { useFeedback } from '../../components/ui/FeedbackProvider.jsx'

export default function WorkGroupCreatePage() {
  const navigate = useNavigate()
  const { toast } = useFeedback()
  const [values, setValues] = useState({
    title: '',
    description: '',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)

  function onChange(field) {
    return (e) =>
      setValues((prev) => ({
        ...prev,
        [field]: e.target.value,
      }))
  }

  async function handleSubmit(e) {
    e.preventDefault()
    if (isSubmitting) return
    const titleTrimmed = values.title.trim()
    if (!titleTrimmed) {
      setError(new Error('Title is required.'))
      return
    }
    setError(null)
    setIsSubmitting(true)
    try {
      const created = await createWorkGroup({
        title: titleTrimmed,
        description: values.description.trim() || null,
      })
      toast({ type: 'success', message: 'Work group created.' })
      navigate(`/work-groups/${created.id}`)
    } catch (err) {
      setError(err)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="page">
      <div className="pageHeader">
        <h1 className="pageTitle">Create Work Group</h1>
        <Link to="/work-groups" className="button buttonGhost">
          Back
        </Link>
      </div>

      <section className="card formCard">
        <div className="cardTitle">Work Group</div>
        <form className="formGrid" onSubmit={handleSubmit}>
          <label className="formField">
            <span className="formLabel">Title</span>
            <input
              className="textInput"
              type="text"
              value={values.title}
              onChange={onChange('title')}
              placeholder="Work group name"
              required
            />
          </label>

          <label className="formField">
            <span className="formLabel">Description</span>
            <textarea
              className="textInput"
              rows={3}
              value={values.description}
              onChange={onChange('description')}
              placeholder="Optional description"
            />
          </label>

          <div className="formActions">
            <button type="submit" className="button buttonPrimary" disabled={isSubmitting}>
              {isSubmitting ? 'Creating...' : 'Create'}
            </button>
          </div>
        </form>

        {error ? (
          <div className="formError">
            {error?.body?.detail || error?.message || 'Failed to create work group.'}
          </div>
        ) : null}
      </section>
    </div>
  )
}
